import type { APIClient } from './../api';
import prefetchBaseQuery from './prefetchBaseQuery';
import type { BuildQueryDescriptorParams } from './utils';

export default function prefetchQuery(
  url: string,
  client: APIClient,
  params?: BuildQueryDescriptorParams,
) {
  return prefetchBaseQuery(url, client, params);
}
